import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { MapService } from '../../services/map.service';
import { ReportService } from '../../services/report.service';
import { TaskService } from '../../services/task.service';
import { UserService } from '../../services/user.service';
import { BaseReportComponent } from '../reports/base-report.component';

export enum OrderStatus {
  Completed = 1,
  Invoiced = 2,
  Closed = 3,
  Cancelled = 4,
  Created = 5,
  Started = 6,
}

@Component({
  selector: 'orders-report-beta',
  templateUrl: './orders-report-beta.component.html',
  styleUrls: ['./orders-report-beta.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class OrdersReportBetaComponent extends BaseReportComponent<any, any, any> {
  public organisationTypeId: number = 0;
  public isBusyOrganisationType: boolean = false;

  public tags: any[] = [];
  public groupTags: any[] = [];
  public costCodes: any[] = [];
  public groupCostCodes: any[] = [];
  public departments: any[] = [];
  public teams: any[] = [];
  public regions: any[] = [];
  public depots: any[] = [];
  public orderStatuses: any[] = [];
  public taskTypes: any[] = [];
  public customers: any[] = [];
  public statusClosed = OrderStatus.Closed;

  constructor(
    reportService: ReportService<any, any>,
    private userService: UserService,
    private mapService: MapService,
    private taskService: TaskService,
  ) {
    super(reportService, false);
    reportService.url = '/api/report/orderbeta';
  }

  ngOnInit() {
    super.ngOnInit();
    this.initializeCurrentUserOrgType();
  }

  public initializeCurrentUserOrgType() {
    this.isBusyOrganisationType = true;
    this.userService
      .getCurrentUserOrg()
      .then((organisation) => {
        this.isBusyOrganisationType = false;
        if (organisation) {
          this.organisationTypeId = organisation.organisationTypeId;
          this.callbackLoadFilterParam();
        }
      })
      .catch((x) => {
        this.isBusyOrganisationType = false;
      });
  }

  public callbackLoadFilterParam() {
    this.tags = [];
    this.groupTags = [];
    this.costCodes = [];
    this.groupCostCodes = [];
    this.departments = [];
    this.teams = [];
    this.regions = [];
    this.depots = [];
    this.orderStatuses = [];
    this.taskTypes = [];
    this.customers = [];

    if (this.filterParam) {
      this.tags.push({ label: 'Please Select', value: null });
      if (this.filterParam.tags) {
        if (this.organisationTypeId != 1) {
          this.filterParam.tags
            .sort((x) => x.id)
            .forEach((x) => {
              this.tags.push({ label: x.description, value: x.id });
            });
        } else {
          var groupTags = [];
          var orgKeys = [];
          this.filterParam.tags.forEach((x) => {
            if (!groupTags[x.organisationName]) {
              orgKeys.push(x.organisationName);
              groupTags[x.organisationName] = { organisationName: x.organisationName, items: [] };
            }

            groupTags[x.organisationName].items.push(x);
          });

          groupTags.sort((x) => x.organisationName);
          this.groupTags.push({ label: 'Please Select', value: null });
          for (var i = 0; i < orgKeys.length; i++) {
            var groupTag = groupTags[orgKeys[i]];

            groupTag.items.forEach((item) => {
              this.groupTags.push({
                label: item.description,
                value: item.id,
                organisationName: item.organisationName,
              });
            });
          }
        }
      }

      this.costCodes.push({ label: 'Please Select', value: null });
      if (this.filterParam.costcodes) {
        if (this.organisationTypeId != 1) {
          this.filterParam.costcodes
            .sort((x) => x.id)
            .forEach((x) => {
              this.costCodes.push({ label: x.name, value: x.id });
            });
        } else {
          var groupCostCodesTmp = [];
          var orgKeys = [];
          this.filterParam.costcodes.forEach((x) => {
            if (!groupCostCodesTmp[x.organisationName]) {
              orgKeys.push(x.organisationName);
              groupCostCodesTmp[x.organisationName] = {
                organisationName: x.organisationName,
                items: [],
              };
            }

            groupCostCodesTmp[x.organisationName].items.push(x);
          });

          groupCostCodesTmp.sort((x) => x.organisationName);

          this.groupCostCodes.push({ label: 'Please Select', value: null });
          for (var i = 0; i < orgKeys.length; i++) {
            var groupCostCodeIns = groupCostCodesTmp[orgKeys[i]];

            groupCostCodeIns.items.forEach((item) => {
              this.groupCostCodes.push({
                label: item.name,
                value: item.id,
                organisationName: item.organisationName,
              });
            });
          }
        }
      }

      this.departments.push({ label: 'Please Select', value: null });
      if (this.filterParam.departments) {
        this.filterParam.departments
          .sort((x) => x.id)
          .forEach((x) => {
            this.departments.push({ label: x.name, value: x.id });
          });
      }

      this.regions.push({ label: 'Please Select', value: null });
      if (this.filterParam.regions) {
        this.filterParam.regions
          .sort((x) => x.id)
          .forEach((x) => {
            this.regions.push({ label: x.name, value: x.id });
          });
      }

      this.depots.push({ label: 'Please Select', value: null });
      if (this.filterParam.depots) {
        this.filterParam.depots
          .sort((x) => x.id)
          .forEach((x) => {
            this.depots.push({ label: x.name, value: x.id });
          });
      }

      //this.orderStatuses.push({label: 'Please Select', value: null});
      if (this.filterParam.statuses) {
        this.filterParam.statuses
          .sort((x) => x.id)
          .forEach((x) => {
            this.orderStatuses.push({ label: x.name, value: x.id });
          });
      }

      this.taskTypes.push({ label: 'Please Select', value: null });
      if (this.filterParam.types) {
        this.filterParam.types
          .sort((x) => x.id)
          .forEach((x) => {
            this.taskTypes.push({ label: x.name, value: x.id });
          });
      }

      this.teams.push({ label: 'Please Select', value: null });
      if (this.filterParam.teams) {
        this.filterParam.teams
          .sort((x) => x.id)
          .forEach((x) => {
            this.teams.push({ label: x.name, value: x.id });
          });
      }

      this.customers.push({ label: 'Please Select', value: null });
      if (this.filterParam.customers) {
        this.filterParam.customers.forEach((x) => {
          this.customers.push({ label: x.label, value: x.value });
        });
      }
    }
  }

  changeSort(event) {
    var event2 = event;
  }

  initDefaultFilter() {
    super.initDefaultFilter();
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '',
      sortOrder: 1,
      filters: {
        completedDateFrom: {},
        completedDateTo: {},
        createdDateFrom: {},
        createdDateTo: {},
        tag: {},
        costCode: {},
        department: {},
        team: {},
        region: {},
        depot: {},
        status: {},
        type: {},
        customer: {},
        supplier: {},
      },
    };
  }

  departmentChange(event) {
    this.filterVal.filters.team = {};
    this.loadTeams(event.value);
  }

  loadTeams(departmentId) {
    this.teams = [];
    this.teams.push({ label: 'Please Select', value: null });
    if (departmentId == null) {
      if (this.filterParam.teams) {
        this.filterParam.teams
          .sort((x) => x.id)
          .forEach((x) => {
            this.teams.push({ label: x.name, value: x.id });
          });
      }
    }
    if (departmentId != null) {
      if (this.filterParam.teams) {
        this.filterParam.teams
          .filter((x) => x.departmentId == departmentId)
          .sort((x) => x.id)
          .forEach((x) => {
            this.teams.push({ label: x.name, value: x.id });
          });
      }
    }
  }
}
